(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baze-carrusel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('baze-photo-carousel')) {
    customElements.define('baze-photo-carousel', class extends HTMLElement {
      connectedCallback() {
        this.stop?.abort();
        this.stop = new AbortController();
        const signal = this.stop.signal;
        const view = this.querySelector('.baze-photos-viewport');
        const group = this.querySelector('.baze-photos-group');
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        let touching = false, dragging = false, previous = 0, resumeAt = 0;
        let x = 0, start = 0, position = 0;
        const fill = () => {
          const width = group.getBoundingClientRect().width;
          if (width <= 12 || !group.children.length) return;
          const needed = Math.ceil(view.clientWidth / width) + 3;
          while(view.children.length < needed) {
            const clone = group.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
            view.appendChild(clone);
          }
          position = width;
          view.scrollLeft = position;
        };
        this.resize?.disconnect();
        this.resize = new ResizeObserver(fill);
        this.resize.observe(view);
        fill();
        view.addEventListener('pointerdown', e => {
          touching = true;
          if(e.pointerType !== 'mouse' || e.button !== 0) return;
          dragging = true; x = e.clientX; start = view.scrollLeft;
          view.setPointerCapture(e.pointerId); view.classList.add('is-dragging'); e.preventDefault();
        }, {signal});
        view.addEventListener('pointermove', e => { if(dragging) view.scrollLeft = start + x - e.clientX; }, {signal});
        const release = () => { if (!touching) return; touching = dragging = false; position = view.scrollLeft; resumeAt = performance.now() + 600; view.classList.remove('is-dragging'); };
        window.addEventListener('pointerup', release, {signal});
        window.addEventListener('pointercancel', release, {signal});
        view.addEventListener('wheel', () => { resumeAt = performance.now() + 600; }, {signal, passive:true});
        const tick = now => {
          const dt = previous ? Math.min(now - previous, 50) : 0; previous = now;
          const width = group.getBoundingClientRect().width;
          if(width > 12 && !document.hidden && !reducedMotion.matches && !touching && now > resumeAt) {
            position += Number(this.dataset.speed || 35) * dt / 1000;
            if(position >= width * 2) position -= width;
            if(position < width) position += width;
            view.scrollLeft = position;
          } else {
            position = view.scrollLeft;
          }
          this.frame = requestAnimationFrame(tick);
        };
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(tick);
      }
      disconnectedCallback() { cancelAnimationFrame(this.frame); this.stop?.abort(); this.resize?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-clientes"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new Map();
  const mount = (scope) => {
    scope.querySelectorAll('.rc-reviews').forEach((section) => {
      if (instances.has(section)) return;
      const track = section.querySelector('.rc-reviews__track');
      const cards = Array.from(track.children);
      if (cards.length < 2) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const copies = cards.map((card) => {
        const copy = card.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.removeAttribute('data-shopify-editor-block');
        copy.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        track.append(copy);
        return copy;
      });
      track.dataset.autoplay = 'true';
      let frame = 0, last = 0, position = 0, distance = 0;
      let visible = false, keyboardPaused = false, pointer = null;
      let touching = false, settling = false, resumeTimer = 0;
      let startX = 0, startY = 0, startScroll = 0, dragging = false;
      const tick = (time) => {
        const delta = last ? Math.min(time - last, 64) : 0;
        last = time;
        position = (position + delta * 0.035) % distance;
        track.scrollLeft = position;
        frame = requestAnimationFrame(tick);
      };
      const update = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        last = 0;
        position = track.scrollLeft;
        if (visible && distance > 0 && !document.hidden && !motion.matches && pointer === null && !touching && !settling && !keyboardPaused) {
          frame = requestAnimationFrame(tick);
        }
      };
      const measure = () => {
        distance = copies[0].offsetLeft - cards[0].offsetLeft;
        update();
      };
      const resumeTouch = () => {
        clearTimeout(resumeTimer);
        if (touching) return;
        settling = false;
        keyboardPaused = false;
        update();
      };
      const waitForScroll = () => {
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(resumeTouch, 160);
      };
      track.addEventListener('touchstart', () => {
        touching = true;
        settling = false;
        keyboardPaused = false;
        clearTimeout(resumeTimer);
        update();
      }, { ...options, passive: true });
      const releaseTouch = (event) => {
        if (event.touches.length) return;
        touching = false;
        settling = true;
        keyboardPaused = false;
        update();
        waitForScroll();
      };
      track.addEventListener('touchend', releaseTouch, { ...options, passive: true });
      track.addEventListener('touchcancel', releaseTouch, { ...options, passive: true });
      track.addEventListener('scroll', () => { if (settling && !touching) waitForScroll(); }, { ...options, passive: true });
      track.addEventListener('scrollend', () => { if (settling && !touching) resumeTouch(); }, options);
      const finish = (event) => {
        if (event.pointerId !== pointer) return;
        pointer = null;
        dragging = false;
        delete track.dataset.dragging;
        update();
      };
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || !event.isPrimary || event.button !== 0 || pointer !== null) return;
        pointer = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        startScroll = track.scrollLeft;
        dragging = false;
        keyboardPaused = false;
        track.setPointerCapture(pointer);
        update();
      }, options);
      track.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointer) return;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        if (!dragging && Math.abs(dx) > 4 && Math.abs(dx) >= Math.abs(dy)) dragging = true;
        if (!dragging) return;
        if (event.cancelable) event.preventDefault();
        track.dataset.dragging = 'true';
        const next = startScroll - dx;
        track.scrollLeft = !motion.matches && distance > 0 ? ((next % distance) + distance) % distance : next;
      }, options);
      track.addEventListener('pointerup', finish, options);
      track.addEventListener('pointercancel', finish, options);
      track.addEventListener('lostpointercapture', finish, options);
      track.addEventListener('dragstart', (event) => event.preventDefault(), options);
      track.addEventListener('focusin', () => { keyboardPaused = !touching && !settling && track.matches(':focus-visible'); update(); }, options);
      track.addEventListener('keydown', () => { keyboardPaused = true; update(); }, options);
      track.addEventListener('focusout', () => { keyboardPaused = false; update(); }, options);
      document.addEventListener('visibilitychange', update, options);
      motion.addEventListener('change', measure, options);
      const resize = new ResizeObserver(measure);
      resize.observe(track);
      const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; update(); });
      observer.observe(section);
      measure();
      instances.set(section, () => {
        cancelAnimationFrame(frame);
        clearTimeout(resumeTimer);
        controller.abort();
        observer.disconnect();
        resize.disconnect();
        copies.forEach((copy) => copy.remove());
        delete track.dataset.autoplay;
        delete track.dataset.dragging;
        instances.delete(section);
      });
    });
  };
  mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [section, cleanup] of instances) if (event.target.contains(section)) cleanup();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
